'use client'

import Link from 'next/link'
import { useCrown } from '@/lib/crownContext'

export default function FancyLogo({ currentUsername }: { currentUsername?: string | null }) {
  const holder = useCrown()
  const isHolder = !!currentUsername && holder !== null && holder === currentUsername
  const gradientClass = isHolder ? 'fancy-gold-text' : 'fancy-gradient-text'

  return (
    <Link
      href="/"
      className={`shrink-0 text-xl font-bold tracking-tight ${gradientClass} scalable-text animating`}
    >
      Weeabets
    </Link>
  )
}
